import api from '../lib/api';
import { toArray } from '../lib/utils';
import type { MessageTemplate } from '../types/messageTemplate';

class MessageTemplateService {
  async getGlobalTemplates(categoryKey?: string): Promise<MessageTemplate[]> {
    const params = categoryKey ? { category_key: categoryKey } : undefined;
    const response = await api.get('/messages/templates/global', { params });
    return toArray(response.data);
  }

  async getUserTemplates(categoryKey?: string): Promise<MessageTemplate[]> {
    const params = categoryKey ? { category_key: categoryKey } : undefined;
    const response = await api.get('/messages/templates/user', { params });
    return toArray(response.data);
  }

  async getTemplateByCategory(categoryKey: string): Promise<MessageTemplate> {
    const response = await api.get(`/messages/templates/category/${categoryKey}`);
    return response.data;
  }

  async getGlobalTemplate(id: number): Promise<MessageTemplate> {
    const response = await api.get(`/messages/templates/global/${id}`);
    return response.data;
  }

  async getUserTemplate(id: number): Promise<MessageTemplate> {
    const response = await api.get(`/messages/templates/user/${id}`);
    return response.data;
  }

  async createGlobalTemplate(data: Partial<MessageTemplate>): Promise<MessageTemplate> {
    const response = await api.post('/messages/templates/global', data);
    return response.data;
  }

  async createUserTemplate(data: Partial<MessageTemplate>): Promise<MessageTemplate> {
    const response = await api.post('/messages/templates/user', data);
    return response.data;
  }

  async updateGlobalTemplate(id: number, data: Partial<MessageTemplate>): Promise<MessageTemplate> {
    const response = await api.put(`/messages/templates/global/${id}`, data);
    return response.data;
  }

  async updateUserTemplate(id: number, data: Partial<MessageTemplate>): Promise<MessageTemplate> {
    const response = await api.put(`/messages/templates/user/${id}`, data);
    return response.data;
  }

  async deleteGlobalTemplate(id: number): Promise<void> {
    await api.delete(`/messages/templates/global/${id}`);
  }

  async deleteUserTemplate(id: number): Promise<void> {
    await api.delete(`/messages/templates/user/${id}`);
  }

  async getCategories(): Promise<any[]> {
    const response = await api.get('/messages/categories');
    return toArray(response.data);
  }
}

export default new MessageTemplateService();
